import InputEmailorPhone from "../InputEmailorPhone";
import InputPassword from "../InputPassword";
import LoginButton from "../LoginButton";
import styles from "./loginblock.module.css";
import LoginWithGoogleButton from "../LoginWithGoogleButton";
import LoginWithFacebookButton from "../LoginWithFacebookButton";
import LoginWithTiktokButton from "../LoginWithTiktokButton";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

export default function LoginBlock() {
  const { t } = useTranslation();
  const [errorEmailPhone, setErrorEmailPhone] = useState("");
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [emailClass, setEmailClass] = useState();
  const [passwordClass, setPasswordClass] = useState();
  const [emailTextValid, setEmailTextValid] = useState(
    "invalid_email_or_phone"
  );
  const [passwordTextValid, setPasswordTextValid] =
    useState("invalid_password");
  const [error, setError] = useState("");

  useEffect(() => {
    if (errorEmailPhone !== "") {
      setEmailClass(styles.emailError);
      setEmailTextValid("invalid_email_or_phone");
    } else if (errorEmailPhone === "" && emailPhoneValue !== "") {
      setEmailClass(styles.emailValid);
      setEmailTextValid("valid_email_or_phone");
    } else {
      setEmailClass();
    }

    if (errorPassword !== "") {
      setPasswordClass(styles.passwordError);
      setPasswordTextValid("invalid_password");
    } else if (errorPassword === "" && passwordValue !== "") {
      setPasswordClass(styles.passwordValid);
      setPasswordTextValid("valid_password");
    } else {
      setPasswordClass();
    }
  }, [errorEmailPhone, errorPassword, emailPhoneValue, passwordValue]);

  return (
    <div className={styles.loginBlock}>
      <h2 className={styles.loginText}>{t("login")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputEmailorPhone
            emailPhoneValue={emailPhoneValue}
            setEmailPhoneValue={setEmailPhoneValue}
            errorEmailPhone={errorEmailPhone}
            setErrorEmailPhone={setErrorEmailPhone}
          />
        </div>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputPassword
            setPasswordValue={setPasswordValue}
            passwordValue={passwordValue}
            errorPassword={errorPassword}
            setErrorPassword={setErrorPassword}
          />
        </div>
        <ul className="col-12">
          <li className={emailClass}>{t(emailTextValid)}</li>
          <li className={passwordClass}>{t(passwordTextValid)}</li>
        </ul>
      </div>
      <div className={`col-12 ${styles.loginButtonContainer}`}>
        <LoginButton
          emailPhoneValue={emailPhoneValue}
          passwordValue={passwordValue}
          errorEmailPhone={errorEmailPhone}
          errorPassword={errorPassword}
          setError={setError}
        />
      </div>
      <div className={`col-12 px-3 ${styles.linkBlock}`}>
        <a href="/reset-password">{t("forgot_password")}</a>
        <a href="/loginotp">{t("login_with_otp")}</a>
      </div>
      <div className={`col-12 ${styles.hrContainer}`}>
        <hr className={styles.leftHr} />
        <span className={styles.hrText}>{t("or")}</span>
        <hr className={styles.rightHr} />
      </div>
      <div className={`col-12 ${styles.loginWithBlock}`}>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithGoogleButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithFacebookButton />
        </div>
        {/* <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithTiktokButton />
        </div> */}
        <p>
          {t("first_time_bhive")} <a href="/signup">{t("signup")}</a>
        </p>
      </div>
    </div>
  );
}
